import { ExerciseReviewPerformanceSubmissionsFragment } from '../views/Review/graphql/fragments/generated/ExerciseReviewPerformance';

export default function getLatestExerciseSubmission(
  submissions?: ExerciseReviewPerformanceSubmissionsFragment[] | null,
  submissionId?: string,
) {
  if (!submissions?.length) {
    return {};
  }
  const latestSubmission = submissions[submissions.length - 1];

  return submissionId
    ? { latestSubmission, isLatestSubmission: submissionId === latestSubmission.id }
    : { latestSubmission };
}
